import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=53e65a56&scoped=true&"
import script from "./Options.vue?vue&type=script&lang=ts&"
export * from "./Options.vue?vue&type=script&lang=ts&"
import style0 from "./Options.vue?vue&type=style&index=0&id=53e65a56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e65a56",
  null
  
)

export default component.exports